module.exports = __webpack_public_path__ + "static/img/paul_henri.26e7e14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paul_henri.png
// module id = 36
// module chunks = 1